import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import StepFileUpload from '../upload/StepFileUpload'
import useUploadHook from '../../hooks/UseUploadHook'
import { ILogementProps } from '../../interfaces/Logement'
import LocativeText from './LocativeText'
import { IStore } from '../../interfaces/Store'
import { STATUS } from '../../enums/common'
import Spinner from '../Spinner'

const index = 0
function LocativeHebergeDomicileSection(props: ILogementProps): ReactElement {
  const { state, setState, validateFile, isPeriodicRemediation } = props
  const { uploadFile } = useUploadHook({
    index,
    setState,
    mainState: state,
    validateFile,
    isPeriodicRemediation,
  })
  const { toggleValidateButton, validationButtonError } = state[0]
  const personStatus = useSelector(
    (store: IStore) => store.personReducer.status
  )
  const {
    folder: { top_heb },
  } = useSelector((store: IStore) => store.folderReducer)

  const shouldDisplayAllDocs =
    (top_heb && ['0', '1'].includes(top_heb) && isPeriodicRemediation) ||
    !isPeriodicRemediation

  if (personStatus !== STATUS.loaded) {
    return (
      <div className="col12 mt1 dFlex alignItemsCenter justifyContentStart">
        <div className="relative pb3 pl3">
          <Spinner small={true} />
        </div>
      </div>
    )
  }
  return (
    <div className="col12 mt6md mt3 mb3lg">
      <p className="mb3">
        Si vous être hébergé, merci de nous transmettre une attestation d’hébergement, un justificatif de domicile émanant de votre hébergeur ainsi qu’un justificatif d’identité.
      </p>
      <LocativeText />
      {shouldDisplayAllDocs && (
        <div className="row">
          <StepFileUpload
            {...{
              ...props,
              index,
              title: 'Attestation d’hébergement',
              loadingSpinnerClassName: 'dFlex justifyContentEnd mt1',
              className: 'wFull mw77',
            }}
          />
        </div>
      )}
      {(top_heb === '0' || top_heb === '1') && isPeriodicRemediation && (
        <div className="row">
          <StepFileUpload
            {...{
              ...props,
              title: "Justificatif d'identité de l'hébergeur",
              fileIndex: 1,
              index,
              className: 'wFull mw77',
            }}
          />
        </div>
      )}
      {shouldDisplayAllDocs && (
        <div className="row">
          <StepFileUpload
            {...{
              ...props,
              title: 'Justificatif de domicile de l’hébergeur',
              fileIndex: !isPeriodicRemediation ? 1 : 2,
              tooltip: 'justificatifHeberge',
              index,
              className: 'wFull mw77',
            }}
          />
        </div>
      )}
      {toggleValidateButton && (
        <div className="row">
          <div className="wFull dFlex flexWrap justifyContentEnd pb1 pb0sm mw77">
            <button
              className="btn btnPrimary btnPrimaryMd wFull wAutoSm"
              type="button"
              onClick={uploadFile}
            >
              Valider les documents
            </button>
            {validationButtonError && (
              <p
                className={`${validationButtonError.type}Error textRight mt1 wFull`}
              >
                {validationButtonError.message}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default LocativeHebergeDomicileSection
